<template>
  <div
    style="border: black solid 1px;width: 100%;padding-top: 141.42%;position: relative;"
  >
    <div v-if="lang === 'Tha' && !data.isLoan" class="container-preview">
      <v-row class="fill-height">
        <v-col cols="12" align-self="start">
          <v-row justify="center">
            <v-col cols="auto">
              <v-img
                class="mt-4"
                :aspect-ratio="1"
                width="100px"
                src="../../../assets/image/Tra-Khrut.gif"
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR ml-12" cols="auto" align-self="start">
              ที่ อว {{ data.number }} <br />
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              class="fontR mr-12"
              cols="auto"
              align-self="start"
              style="min-width: 180px"
            >
              <span
                v-for="(item, index) in data.addrHead"
                :key="'addrH' + index"
                >{{ item }}<br
              /></span>
              <span v-for="(item, index) in data.addr" :key="'addr' + index"
                >{{ item }}<br
              /></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR mx-12" style="text-indent: 8em;">
              {{ data.paragraph }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR mx-12 text-center">
              ให้ไว้ ณ วันที่
              {{
                $toThaiNumber(
                  $dateFormat(new Date().toISOString().substr(0, 10), {
                    format: 'DD'
                  })
                )
              }}
              เดือน
              {{
                $dateFormat(new Date().toISOString().substr(0, 10), {
                  format: 'MMMM'
                })
              }}
              พ.ศ.
              {{
                $toThaiNumber(
                  $dateFormat(new Date().toISOString().substr(0, 10), {
                    format: 'YYYY',
                    addValue: 543
                  })
                )
              }}
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col cols="auto" class="fontR mx-12 text-center">
              <div class="mr-8">
                ({{ data.exec.employeeNamePositionTha || 'ชื่อ' }}) <br />
                {{
                  data.exec.employeeNamePositionTha
                    ? data.exec.positionExecNameTha +
                      data.exec.organizationExecLevel1NameTha
                    : 'ตำแหน่ง'
                }}
                <br />
                {{ data.replace }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col align-self="end" class="mb-5">
          <v-row>
            <v-col cols="auto" class="fontR mx-12">
              <div class="mr-8">
                <span
                  v-for="(item, index) in data.footer"
                  :key="'footer' + index"
                >
                  {{ item }}<br
                /></span>
              </div>
            </v-col>
          </v-row>
          <v-row align="start">
            <v-col cols="auto" class="fontR ml-12">
              หมายเหตุ
            </v-col>
            <v-col cols="auto" class="fontR">
              <div class="mr-8">
                ๑. หนังสือรับรองฉบับนี้ใช้ได้ไม่เกิน ๙๐ วัน
                นับตั้งแต่วันที่ออกหนังสือนี้ <br />
                <span
                  v-if="
                    data.reqFromReasonId === 1 || data.reqFromReasonId === 2
                  "
                >
                  ๒. หนังสือฉบับนี้ใช้สำหรับ {{ data.reason }} เท่านั้น
                </span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div v-if="lang === 'Eng' && !data.isLoan" class="container-preview">
      <v-row class="fill-height">
        <v-col cols="12" align-self="start">
          <v-row class="mt-8">
            <v-col cols="auto">
              <v-img
                class=" ml-12"
                :aspect-ratio="1"
                width="50px"
                src="../../../assets/image/logo_cmu.jpg"
              ></v-img>
            </v-col>
            <v-col cols="8" style="font-size: 12px" justify="center">
              <div>
                {{ data.headerEng.eng }}, Chiang Mai University <br />
                {{ data.headerEng.tha }}
                มหาวิทยาลัยเชียงใหม่
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR ml-12 mt-5" cols="auto" align-self="start">
              Ref: No. {{ data.number }} <br />
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row>
            <v-col class="fontR mx-12">
              {{
                this.$dateFormat(new Date().toISOString().substr(0, 10), {
                  format: 'MMMM',
                  locale: 'en'
                }) +
                  ' ' +
                  this.$dateFormat(new Date().toISOString().substr(0, 10), {
                    format: 'D',
                    locale: 'en'
                  }) +
                  ' ,' +
                  this.$dateFormat(new Date().toISOString().substr(0, 10), {
                    format: 'YYYY',
                    locale: 'en'
                  })
              }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR mx-12">
              To Whom It May Concern:
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR mx-12">
              {{ data.paragraph }}
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="auto" class="fontR mx-12">
              <div class="mr-8">
                {{ data.exec.employeeNamePositionEng || 'ชื่อ' }} <br />
                {{
                  data.exec.employeeNamePositionEng
                    ? data.exec.positionExecNameEng +
                      ' ' +
                      data.exec.organizationExecLevel1NameEng
                    : 'ตำแหน่ง'
                }}
                <br />
                {{ data.replace }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col align-self="end" class="mb-5">
          <hr class="mx-12 mb-2" />
          <v-row align="start" class="px-12">
            <v-col cols="auto" style="font-size: 7px" class="py-0">
              <div>
                {{ data.footerEng.contactAddressEng }}
              </div>
            </v-col>
            <v-col cols="auto" style="font-size: 7px" class="py-0">
              <div>
                {{ data.footerEng.contactEmailEng }}
              </div>
            </v-col>
          </v-row>
          <v-row align="start" class="px-12">
            <v-col cols="auto" style="font-size: 7px" class="py-0">
              <div>
                {{ data.footerEng.phoneNumberEng }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div v-if="data.isLoan" class="container-preview">
      <v-row class="fill-height">
        <v-col cols="12" align-self="start">
          <v-row justify="center">
            <v-col cols="auto">
              <v-img
                class="mt-4"
                :aspect-ratio="1"
                width="100px"
                src="../../../assets/image/Tra-Khrut.gif"
              ></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR ml-12" cols="auto" align-self="start">
              ที่ อว {{ data.number }} <br />
            </v-col>
            <v-spacer></v-spacer>
            <v-col
              class="fontR mr-12"
              cols="auto"
              align-self="start"
              style="min-width: 180px"
            >
              <span
                v-for="(item, index) in data.addrHead"
                :key="'addrH' + index"
                >{{ item }}<br
              /></span>
              <span v-for="(item, index) in data.addr" :key="'addr' + index"
                >{{ item }}<br
              /></span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="fontR pb-0 pt-6 text-center"
              style="margin-left: 70px"
            >
              {{
                this.$dateFormat(new Date().toISOString().substr(0, 10), {
                  format: 'MMMM'
                })
              }}
              {{
                this.$dateFormat(new Date().toISOString().substr(0, 10), {
                  format: 'YYYY',
                  addValue: 543
                })
              }}
            </v-col>
          </v-row>
          <v-row>
            <v-col class="fontR mx-12">
              <div v-if="data.reqFromReasonId === 5">
                <div class="my-2">
                  เรื่อง
                  ขอส่งรายชื่อผู้ขอกู้เงินโครงการสินเชื่อสวัสดิการสำหรับบุคลากรภาครัฐ
                  ในสังกัดมหาวิทยาลัยเชียงใหม่
                </div>
                <div class="my-2">
                  เรียน กรรมการผู้จัดการธนาคารกรุงไทย
                </div>
                <div class="my-2">
                  อ้างถึง ข้อตกลงระหว่างธนาคารกรุงไทยกับมหาวิทยาลัยเชียงใหม่
                  ฉบับลงวันที่ ๑๕ กันยายน ๒๕๖๓
                </div>
              </div>
              <div v-if="data.reqFromReasonId === 4">
                <div class="my-2">
                  เรื่อง การกู้เงินโครงการสวัสดิการเงินกู้เพื่อที่อยู่อาศัย
                  (สวัสดิการไม่มีเงินฝาก)
                </div>
                <div class="my-2">
                  เรียน กรรมการผู้จัดการธนาคารอาคารสงเคราะห์
                </div>
                <div class="my-2">
                  อ้างถึง
                  ข้อตกลงระหว่างธนาคารอาคารสงเคราะห์กับมหาวิทยาลัยเชียงใหม่
                  <br />
                  <div style="padding-left:4em">
                    ฉบับลงวันที่ ๑๕ กุมภาพันธ์ ๒๕๖๓ (รหัสสวัสดิการ ๐๐๓W๕๓๐๐๒๓)
                  </div>
                </div>
              </div>

              <div class="my-2" style="text-indent: 8em;">
                {{ data.paragraph }}
              </div>
              <div
                v-for="(item, index) in data.additionalParagraph"
                :key="`para${index}`"
                class="my-2"
                style="text-indent: 8em;"
              >
                {{ item }}
              </div>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col cols="auto" class="fontR mx-12 text-center">
              <div class="mr-8 mb-6">
                ขอแสดงความนับถือ
              </div>
              <div class="mr-8">
                ({{ data.exec.employeeNamePositionTha || 'ชื่อ' }}) <br />
                {{
                  data.exec.employeeNamePositionTha
                    ? data.exec.positionExecNameTha +
                      data.exec.organizationExecLevel1NameTha
                    : 'ตำแหน่ง'
                }}
                <br />
                {{ data.replace }}
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col align-self="end" class="mb-5">
          <v-row>
            <v-col cols="auto" class="fontR mx-12">
              <div class="mr-8">
                <span
                  v-for="(item, index) in data.footer"
                  :key="'footer' + index"
                >
                  {{ item }}<br
                /></span>
              </div>
            </v-col>
          </v-row>
          <v-row align="start">
            <v-col cols="auto" class="fontR ml-12">
              หมายเหตุ
            </v-col>
            <v-col cols="auto" class="fontR">
              <div class="mr-8">
                ๑. หนังสือรับรองฉบับนี้ใช้ได้ไม่เกิน ๙๐ วัน
                นับตั้งแต่วันที่ออกหนังสือนี้ <br />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {}
    },
    lang: {
      type: String,
      default: 'eng'
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Sarabun&display=swap');
.container-preview {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 25px;
  color: black;
}
.fontR {
  font-family: 'Sarabun', sans-serif;
  font-size: 10px;
}
</style>
